import {HttpClient} from '@angular/common/http';
import {Injectable, EventEmitter} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ConstantProvider} from './constants.service';
import {EmotionReportProvider} from './emotion-report';
import {DataSegmentProvider} from './data-segment';
import {ToastService} from './toast.service';
import {Capacitor} from '@capacitor/core';
import {Geolocation} from '@capacitor/geolocation';
import {CommonService} from './common.service';
// import {Diagnostic} from '@awesome-cordova-plugins/diagnostic/ngx';

declare let google;
// eslint-disable-next-line @typescript-eslint/naming-convention
declare let MarkerClusterer;


@Injectable({
  providedIn: 'root'
})
export class MapProvider {
  viewDetailsActive = false;
  app: any;
  public coordinates;
  public mapObject;
  public viewAll;
  emotionNames: any;
  locationData: any;
  emotionSelected: EventEmitter<any> = new EventEmitter();
  emotionClosed: EventEmitter<boolean> = new EventEmitter();
  markersList = [];
  currentUserLocation = [];

  constructor(public http: HttpClient,
              private commonService: CommonService,
              private toast: ToastService,
              public dataSegmentService: DataSegmentProvider,
              public emotionReportService: EmotionReportProvider,
              private constants: ConstantProvider,
              public translate: TranslateService) {
    this.app = this.constants;
    this.getTranslatedStrings();
  }

  /**
   * Initialize map object
   */
  initializeMapObject(mapObject, viewAllValue) {
    this.mapObject = mapObject;
    this.viewAll = viewAllValue;
  }

  /**
   * Get current location(lat, lng) of user
   */
  async getLocation() {
    if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
      try {
        const checkPermission = await Geolocation.checkPermissions();
        if (checkPermission.coarseLocation !== 'denied' || checkPermission.location !== 'denied') {
          const coordinates = await Geolocation.getCurrentPosition();
          if (coordinates) {
            this.showPosition(coordinates);
          } else {
            this.setDefaultCoordinates();
          }
        } else {
          this.setDefaultCoordinates();
        }
      } catch (e) {
        this.setDefaultCoordinates();
      }
    } else {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(this.showPosition.bind(this), this.setDefaultCoordinates.bind(this),
          {timeout: 10000});
      }
    }
  }

  getGeoLocation = () => new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject));

  /**
   * Callback of getLocation.
   *
   * @param position - contains lat, lng of location
   */
  showPosition(position) {
    this.coordinates = {lat: position.coords.latitude, lng: position.coords.longitude};
    localStorage.setItem('currentUserLocation', this.coordinates);

    this.moveToLocation(this.coordinates.lat, this.coordinates.lng);

    //Retrieve emotion reports
    this.emotionReportService.getEmotionReport(this.coordinates)
      .subscribe((emotionReports: any) => {
        const emotionReportData = [];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let j = 0; j < this.markersList.length; j++) {
          this.markersList[j].setMap(null);
        }
        this.markersList = [];

        for (let i = 0; i < emotionReports.data.length; i++) {
          const emotionReport: any = {};
          this.markersList = [];
          emotionReport.emotions = emotionReports.data[i].emotions;
          emotionReport.location = emotionReports.data[i].location;
          // emotionReport.location = emotionReports.data[i].coordinates[0];
          // eslint-disable-next-line no-underscore-dangle
          emotionReport.name = emotionReports.data[i].title ? emotionReports.data[i].title : emotionReports.data[i].name;
          emotionReport.type = emotionReports.data[i].type;
          emotionReport.title = emotionReports.data[i].title ? emotionReports.data[i].title : emotionReports.data[i].name;
          emotionReport.projectType = emotionReports.data[i].projectType;
          emotionReport.created_time = emotionReports.data[i].created_time;
          emotionReportData.push(emotionReport);

          if (i === emotionReports.data.length - 1) {
            this.displayMarkers(emotionReportData);
          }
        }
      });
  }

  /**
   * Error callback of getLocation(). Set's default location for map
   */
  setDefaultCoordinates(pos?: any) {
    this.coordinates = this.app.defaultLocation;

    this.emotionReportService.getEmotionReport(this.coordinates)
      .subscribe((emotionReports: any) => {
        const emotionReportData = [];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let j = 0; j < this.markersList.length; j++) {
          this.markersList[j].setMap(null);
        }
        this.markersList = [];
        for (let i = 0; i < emotionReports.data.length; i++) {
          const emotionReport: any = {};
          emotionReport.emotions = emotionReports.data[i].emotions;
          emotionReport.location = emotionReports.data[i].location;
          // emotionReport.location = emotionReports.data[i].coordinates[0];
          emotionReport.popularity = emotionReports.data[i].popularity;
          // eslint-disable-next-line no-underscore-dangle
          // changed due to group by cordinates
          emotionReport.name = emotionReports.data[i].title ? emotionReports.data[i].title : emotionReports.data[i].name;
          emotionReport.title = emotionReports.data[i].title ? emotionReports.data[i].title : emotionReports.data[i].name;
          emotionReport.type = emotionReports.data[i].type;
          emotionReport.address = emotionReports.data[i].address;
          emotionReport.created_time = emotionReports.data[i].created_time;
          emotionReport.projectType = emotionReports.data[i].projectType;
          emotionReport.image = emotionReports.data[i].emotionImage ? emotionReports.data[i].emotionImage[0] : null;
          emotionReportData.push(emotionReport);

          if (i === emotionReports.data.length - 1) {
            this.displayMarkers(emotionReportData);
          }
        }
      });
  }

  moveToLocation(lat, lng) {
    const projectObj: any = localStorage.getItem('projectType');
    console.log(projectObj);
    if (projectObj === 'space') {
      console.log('if');
      const center = new google.maps.LatLng(this.constants.spaceDefaultLocation.lat, this.constants.spaceDefaultLocation.lng);
      this.mapObject.panTo(center);
    } else if (projectObj === 'globalYarning') {
      console.log('else if');
      const center = new google.maps.LatLng(this.constants.yarningDefaultLocation.lat, this.constants.yarningDefaultLocation.lng);
      this.mapObject.panTo(center);
    } else {
      console.log('else');
      const center = new google.maps.LatLng(lat, lng);
      this.mapObject.panTo(center);
    }
  }

  displayMarkers(emotionReportData) {
    const emotionColors = this.app.emotionColors;
    const radius = this.app.markerRadius;
    const that = this;

    let emotionNames: any;
    this.translate.get([
      'happy',
      'excited',
      'proud',
      'inspired',
      'empowered',
      'angry',
      'threatened',
      'content',
      'surprised',
      'amused',
      'hopeful',
      'safe',
      'anxious',
      'worried',
      'sad',
      'powerless',
      'desperate',
      'displaced',
      'depressed'
    ]).subscribe(
      (values) => {
        emotionNames = {
          happy: values.happy,
          excited: values.excited,
          proud: values.proud,
          inspired: values.inspired,
          empowered: values.empowered,
          angry: values.angry,
          threatened: values.threatened,
          content: values.content,
          surprised: values.surprised,
          amused: values.amused,
          hopeful: values.hopeful,
          safe: values.safe,
          anxious: values.anxious,
          worried: values.worried,
          sad: values.sad,
          powerless: values.powerless,
          desperate: values.desperate,
          displaced: values.displaced
        };
      });

    for (let i = 0; i < emotionReportData.length; i++) {
      const emotionsTemp = emotionReportData[i].emotions;
      let emotions = emotionReportData[i].emotions;
      const template = [
        '<?xml version="1.0"?>',
        '<svg width="' + this.app.markerSVGWidth + '" height="' + this.app.markerSVGHeight + '" ' +
        'wBox="0 0 100 100"  xmlns="http://www.w3.org/2000/svg">'];

      let emotionsQuery: Array<string> = [];

      emotionsQuery = JSON.parse(sessionStorage.getItem('emotionsQuery'));

      let intersection = [];
      if (emotionsQuery !== null && emotionsQuery.length > 0 && emotionsQuery[0] !== 'All') {
        intersection = emotionsTemp.filter(x => (emotionsQuery.indexOf(x) !== -1));
        emotions = intersection;
      }

      let emotionLength = emotions ? emotions.length : 0;
      if (emotionLength > 3) {
        emotionLength = 3;
      }

      for (let emotion = 0; emotion < emotionLength; emotion++) {
        const cy = this.app.markerCY;
        // eslint-disable-next-line max-len
        const temp = '<circle stroke="white" stroke-width="2" cx="' + this.app.markerCX + '" cy="' + cy + '" r="' + radius[emotion] + '" fill="'
          + emotionColors[emotions[emotion].toLowerCase()]
          + '"/>';
        template.push(temp);
      }
      template.push('</svg>');
      const svg: string = template.join('\n');
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(emotionReportData[i].location[1], emotionReportData[i].location[0]),
        map: this.mapObject,
        icon: {
          // eslint-disable-next-line max-len
          url: emotionReportData[i].type === 'site' ? '/assets/img/svg/office.svg' : (emotionReportData[i].type === 'event' ? '/assets/img/svg/flag.svg' : 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg)),
          scaledSize: new google.maps.Size(40, 40)
        },
        optimized: false,
        zIndex: 999
      });

      this.markersList.push(marker);

      //Performs clustering
      if (i === emotionReportData.length - 1) {
        const tempMarkerCluster: any = new MarkerClusterer(that.mapObject, this.markersList,
          {imagePath: './assets/icon/cluster.png', minimumClusterSize: 10});
      }


      google.maps.event.addListener(marker, 'click', ((markerObj: any, index: any) => () => {
        this.emotionSelected.emit(emotionReportData[i]);
      })(marker, i));

      google.maps.event.addListener(this.mapObject, 'click', (event) => {
        this.emotionClosed.emit(true);
      });
    }
  }

  emotionSelectedEmitter() {
    return this.emotionSelected;
  }

  emotionClosedEmitter() {
    return this.emotionClosed;
  }

  storeEmotionData(emotions) {
    this.viewDetailsActive = !this.viewDetailsActive;
    const emotion = emotions[1].split('-');
    const emotionData = [];

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < emotion.length; i++) {
      if (emotion[i]) {
        emotionData.push(emotion[i]);
      }
    }
    localStorage.setItem('viewDetailEmotions', JSON.stringify(emotionData));
    this.storeLocationData(emotions[0], 'EmotionListing');
  }

  storeLocationData(location, pageName) {
    const temp = location.split('_');
    this.locationData = [parseFloat(temp[0]), parseFloat(temp[1])];
    localStorage.setItem('viewDetailLocation', JSON.stringify(this.locationData));
  }

  /**
   * Function to get the translated strings from json file
   */
  getTranslatedStrings() {
    this.translate.get([
      'happy',
      'excited',
      'proud',
      'inspired',
      'empowered',
      'angry',
      'threatened',
      'content',
      'surprised',
      'amused',
      'hopeful',
      'safe',
      'anxious',
      'worried',
      'sad',
      'powerless',
      'desperate',
      'displaced'
    ]).subscribe(
      values => {
        this.emotionNames = {
          happy: values.happy,
          excited: values.excited,
          proud: values.proud,
          inspired: values.inspired,
          empowered: values.empowered,
          angry: values.angry,
          threatened: values.threatened,
          content: values.content,
          surprised: values.surprised,
          amused: values.amused,
          hopeful: values.hopeful,
          safe: values.safe,
          anxious: values.anxious,
          worried: values.worried,
          sad: values.sad,
          powerless: values.powerless,
          desperate: values.desperate,
          displaced: values.displaced
        };
      });
  }
}

